var React = require('react');

function MailiconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.37516 0.955811H15.6252C15.8351 0.955811 16.0365 1.0245 16.185 1.14677C16.3334 1.26903 16.4168 1.43486 16.4168 1.60777V12.0391C16.4168 12.2121 16.3334 12.3779 16.185 12.5002C16.0365 12.6224 15.8351 12.6911 15.6252 12.6911H1.37516C1.1652 12.6911 0.963836 12.6224 0.81537 12.5002C0.666904 12.3779 0.583496 12.2121 0.583496 12.0391V1.60777C0.583496 1.43486 0.666904 1.26903 0.81537 1.14677C0.963836 1.0245 1.1652 0.955811 1.37516 0.955811ZM8.54766 6.61679L3.4715 3.06686L2.44629 4.06045L8.55795 8.33405L14.5596 4.05719L13.5241 3.07077L8.54845 6.61679H8.54766Z"}));
}

MailiconInline.defaultProps = {"width":"17","height":"13","viewBox":"0 0 17 13"};

module.exports = MailiconInline;

MailiconInline.default = MailiconInline;
